import React from 'react';

import debounce from 'lodash/debounce';

import { scrollToTop } from '../../../helpers';

import { Wrapper, RoundButton, Icon } from './BackToTop.styles';

interface State {
    isBackToTopButtonShown: boolean;
}

export class BackToTop extends React.Component<any, State> {
    constructor(props: any) {
        super(props);
        this.checkBackToTopStateOnScroll = debounce(
            this.checkBackToTopStateOnScroll.bind(this),
            100,
        );
        this.state = {
            isBackToTopButtonShown: false,
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.checkBackToTopStateOnScroll);
        this.checkBackToTopStateOnScroll();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkBackToTopStateOnScroll);
    }

    checkBackToTopStateOnScroll() {
        const { isBackToTopButtonShown } = this.state;

        if (window.scrollY > 300) {
            if (!isBackToTopButtonShown) {
                this.setState({ isBackToTopButtonShown: true });
            }
        } else {
            this.setState({ isBackToTopButtonShown: false });
        }
    }

    render() {
        const { isBackToTopButtonShown } = this.state;

        return (
            <Wrapper isBackToTopButtonShown={isBackToTopButtonShown}>
                <RoundButton
                    onClick={() => {
                        scrollToTop();
                    }}
                    onTouchEnd={() => {
                        scrollToTop();
                    }}
                >
                    <Icon viewBox="0 0 8 16">
                        <polygon
                            points="-0.033,3.269 4.18,7.408 -0.053,11.557 1.84,13.424 5.725,9.608 7.947,7.425 5.724,5.243 1.839,1.424"
                            transform="rotate(-90, 4, 7)"
                        />
                    </Icon>
                </RoundButton>
            </Wrapper>
        );
    }
}
